import axios from 'axios';
import { ElMessage } from 'element-plus';
import { API_CONFIG } from '@/config/api';
import router from '@/router'; // 引入路由实例

// 创建 axios 实例
const service = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // console.log('Request sent:', config); // 添加日志
    // 在发送请求之前做些什么
    // 将 config.url 拼接上 API_CONFIG.baseURL
    if (config.url) {
      config.url = `${API_CONFIG.baseURL}${config.url}`;
    }
    return config;
  },
  (error) => {
    // 处理请求错误
    console.error(error);
    return Promise.reject(error);
  }
);

// 定义需要单独处理的错误码数组
const errorsToHandleSeparately = [40001, 40002, 40006, 40016, 40020, 40025, 40102, 40103, 40207, 40301, 40311, 40317];

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // console.log('Response received:', response); // 添加日志
    // 对响应数据做点什么
    const res = response.data;
    if (res.status === 40310) {
      // 清除 localStorage
      localStorage.clear();
      // 返回到 auth 界面
      router.push('/auth'); 
      return Promise.reject(new Error('您的权限已过期，请重新登录'));
    }
    if (res.status !== 100) {
      if (errorsToHandleSeparately.includes(res.status)) {
        // 如果是需要单独处理的错误码，直接抛出错误
        return Promise.reject(new Error(res.error || `错误码: ${res.status}`));
      }
      ElMessage.error(res.message || '请求失败');
      return Promise.reject(new Error(res.message || '请求失败'));
    } else {
      return res;
    }
  },
  (error) => {
    // 处理响应错误
    console.error('Response error:', error);
    if (!errorsToHandleSeparately.some(code => error.message.includes(code))) {
      ElMessage.error(error.message || '请求失败');
    }
    return Promise.reject(error);
  }
);

export default service;